import { PricingTranslations } from './types';

export const enTranslations: PricingTranslations = {
    bookDemoButtonText: "Book a Demo",
    section: {
        title: "Flexible Pricing for Medical Institutions",
        description: "Whether you're a medical school, a deanery, or a hospital education lead — we’ve got you covered. Clinical Metrics helps your students and junior doctors practise safely and improve faster, with pricing designed for educational institutions.",
        toggleMonthly: "1–29 users",
        toggleYearly: "30 users or more",
        perMonth: " per user / month",
        perYear: " per user / year"
    },
    plans: {
        basic: {
            title: "Basic",
            details: "Give your learners access to unlimited interactive cases. Designed for self-directed learning with key performance metrics.",
            features: [
                "57 diseases",
                "Chatbot patients",
                "Basic analytics"
            ],

        },
        plus: {
            title: "Plus+",
            details: "Enable learners to explore cases independently while giving educators insight and tools to guide learning, track progress, and taylor classes.",
            features: [
                "All Basic features",
                "Advanced analytics",
                "Research platform access",
                "Monthly drop-in teaching sessions + video demo access",
                "On-site support every 6 months"
            ]
        },
        expert: {
            title: "Expert",
            details: "Designed for institutions looking for deep integration, regular support, and research-ready data. This lets you build a structured curriculum.",
            features: [
                "All Plus+ features",
                "Research data with summary stats from our Clinical Metrics team",
                "Weekly drop-in teaching sessions",
                "On-site support every 3 months"
            ]
        }
    },
    testimonialsTitle: "See What Others Say",
    bookDemoTextForTestimonials: "Schedule directly in our calendar",
    testimonials: [
        "Perfect for medical schools and deaneries looking to add structured simulation into their curriculum.",
        "We use Clinical Metrics to prepare students for OSCEs and finals. The feedback tools help them reflect and improve.",
        "Our junior doctors love being able to practise on demand — and the analytics make it easy to track progress."
    ],
    aboutCard: {
        title: "Simulation Training for Medical Professionals",
        detail:
            "Clinical Metrics is an advanced medical education platform that simulates the pressures of a busy emergency department, helping students and junior doctors develop clinical reasoning, prioritisation, and patient management skills. Learners manage realistic virtual patients from history-taking to investigations, documentation, treatment, and decision-making, while educators receive anonymised performance insights to support more effective teaching and targeted feedback."
    },
    whoIsThisFor: {
        title: "Who is this for?",
        detail: "Clinical Metrics is built for medical schools, deaneries, and hospital education leads seeking to give their students and junior doctors safe, repeatable practice. With 57 diseases across specialties from Cardiology to Orthopaedics, and an unlimited number of patient scenarios generated from our underlying disease models, there’s no need to write and retire cases after a single use. Students can practise on demand, and educators can monitor progress with powerful analytics. For those involved in educational research, we also offer a dedicated research platform and expert support to help turn insights into published work."
    },
    whyVital: {
        title: "Why is this vital?",
        detail: "Clinical Metrics saves time, reduces costs, and delivers a high-calibre training experience at scale. There’s no need to create and manage endless case materials — our platform generates unlimited, realistic patient scenarios instantly. Students can practise as often as they need, while educators focus on teaching rather than administration. With powerful analytics and on-demand learning, Clinical Metrics helps institutions provide exceptional training without the overheads of traditional methods."
    },
    whoWeAre: {
        title: "Who We Are",
        detail: "We’re a team of doctors and nurses who’ve been there. We know the pressure of trying to learn medicine with outdated tools — because we’ve lived it. Clinical Metrics was created by Caroline Morton (GP and epidemiologist turned software engineer), Maxwell Flitton (emergency nurse with a background in physics), and Toby Raupach (Consultant Cardiologist and Head of Medical Education). We’ve sat the exams, taught the students, and worked on the wards. Now, we’re building the tools we wish we had."
    },
    deal: "Summer Deal",
    yearlyPlan: "per user / year (save 2 months!)"
};
